import { useAppSelector } from "~/ui-rtk/app/hooks"
import { selectCurrentCompany } from "~/ui-rtk/app/selectors/company.selector"

export default function useCurrentCompany() {
  return useAppSelector(selectCurrentCompany)
}
